import InpageAnchor from "./InpageAnchor";

export default class introController {
	constructor() {
		this.inpageAnchor = new InpageAnchor();
		this.enterBtns = Array.from(document.querySelectorAll(".js-enter-doc"));
		this.btnClicked = ::this.btnClicked;
		this.header = document.querySelector("header");
		this.initEvents();
	}

	getHeight(element) {
		return element.getBoundingClientRect().height;
	}

	btnClicked(e) {
		e.preventDefault();
		const offset = this.getHeight(this.header);
		this.inpageAnchor.onLinkClicked(e, offset);
	}

	initEvents() {
		this.enterBtns.forEach(btn => {
			btn.addEventListener("click", this.btnClicked);
		});
	}
}



// WEBPACK FOOTER //
// ./Components/IntroController.js